import { render, staticRenderFns } from "./FormArticleJoint.vue?vue&type=template&id=77210263&"
import script from "./FormArticleJoint.vue?vue&type=script&lang=js&"
export * from "./FormArticleJoint.vue?vue&type=script&lang=js&"
import style0 from "./FormArticleJoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormArticleJoint.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports